export default {"src":"/_next/static/media/Top.8a1b36fd.svg","height":60,"width":1440,"blurWidth":0,"blurHeight":0};